export { default as NTooltip, tooltipProps } from './src/Tooltip';
